import { useState } from "react";
import { Clock } from "lucide-react";
import { PageHeader, EmptyState } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { canSee, isManagerRole } from "@/lib/api";
import { mesAnterior } from "@/components/ponto/util";
import { ResumoMes } from "@/components/ponto/ResumoMes";
import { EscalaMes } from "@/components/ponto/EscalaMes";
import { Espelho } from "@/components/ponto/Espelho";
import { Relogio } from "@/components/ponto/Relogio";
import { Cadastros } from "@/components/ponto/Cadastros";

export default function Ponto() {
  const { session } = useAuth();
  const [comp, setComp] = useState(mesAnterior());
  const [tab, setTab] = useState("resumo");
  const [colab, setColab] = useState(null);
  const u = session.user;
  if (!canSee(u, "ponto")) {
    return <EmptyState icon={Clock} title="Sem acesso ao Ponto e escala" text="Disponível nos planos com o módulo Ponto e escala, para Dono, Administrador e Gerente." />;
  }
  const podeEditar = isManagerRole(u) || (u.contador?.operar || []).includes("ponto");
  const abrirEspelho = (id) => { setColab(id); setTab("espelho"); };
  return (
    <div className="space-y-6" data-testid="ponto-page">
      <PageHeader eyebrow="Gente" title="Ponto e escala" subtitle="Escala, relógio de ponto, espelho, AEJ e horas para a folha"
        actions={<label className="flex items-center gap-2 text-sm">Competência
          <Input type="month" value={comp} onChange={(e) => e.target.value && setComp(e.target.value)} className="w-40" data-testid="ponto-competencia" /></label>} />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="resumo" data-testid="ponto-tab-resumo">Fechamento do mês</TabsTrigger>
          <TabsTrigger value="escala" data-testid="ponto-tab-escala">Escala</TabsTrigger>
          <TabsTrigger value="espelho" data-testid="ponto-tab-espelho">Espelho de ponto</TabsTrigger>
          <TabsTrigger value="relogio" data-testid="ponto-tab-relogio">Relógio de ponto</TabsTrigger>
          <TabsTrigger value="cadastros" data-testid="ponto-tab-cadastros">Cadastros e regras</TabsTrigger>
        </TabsList>
        <TabsContent value="resumo" className="mt-4"><ResumoMes comp={comp} podeEditar={podeEditar} onEspelho={abrirEspelho} isAdmin={["owner", "admin"].includes(u.role)} /></TabsContent>
        <TabsContent value="escala" className="mt-4"><EscalaMes comp={comp} podeEditar={podeEditar} /></TabsContent>
        <TabsContent value="espelho" className="mt-4"><Espelho comp={comp} colab={colab} setColab={setColab} podeEditar={podeEditar} /></TabsContent>
        <TabsContent value="relogio" className="mt-4"><Relogio podeEditar={podeEditar} /></TabsContent>
        <TabsContent value="cadastros" className="mt-4"><Cadastros podeEditar={podeEditar} /></TabsContent>
      </Tabs>
    </div>
  );
}
